import { RootStore } from 'common/interfaces/root';

export const rootInitState: RootStore = {
  lang: '',
  error: null,
  loading: true,
};
